import Vue from 'vue'
import Vuex from 'vuex'
import info from  "@/config/index"
import menu from "@/config/menu";
import store from '@/store'

Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    mob: false,
    lang: 'en',
    display: {
      menu: false,
    },
    menuList: {
      firstMenu: menu.menuList,
      secondMenu: [],
      thirdMeun: [],
      fourthMeun: [],
    },
    mid: 0,
    virtualLink: null,
    pInfo:info.pInfo,
  },
  mutations: {
    SET_LANG(state, data) {
      state.lang = data;
    },
    SET_MID(state, data) {
      state.mid = data;
    },
    SET_DISPLAY_SHOW(state, data) {
      state.display.menu = data;
    },
    SET_MENU_LIST(state, data) {
      state.menuList = data;
    },
    SET_MOB(state, data) {
      state.mob = data;
    },
    SET_VIRTUAL_LINK(state, data) {
      state.virtualLink = data;
    }
  },
  actions: {
    fallsMeun({
      commit
    }, payload) {

      let secondMenu = [],
        thirdMeun = [],
        fourthMeun = [];
      // console.log(payload.h, payload.i, payload.j, payload.k);
      if (payload.h == 1) {
        if (!payload.i) payload.i = 0;
        if (!payload.j) payload.j = 0;
        if (payload.i == 0 && payload.j == 0) {
          if (!payload.k) payload.k = 0;
        }
      }

      if (payload.h == 3) {
        if (!payload.i) payload.i = 0;
      }

      //二级菜单：
      if (payload.h >= 0) {
        secondMenu = menu.menuList[payload.h].list;
      }

      //三级菜单：
      thirdMeun = [];
      if (secondMenu.length > 0 && payload.i >= 0) {
        thirdMeun = secondMenu[payload.i].list;
      }
      //四级菜单：
      fourthMeun = [];
      if (thirdMeun.length > 0 && payload.j >= 0) {
        fourthMeun = thirdMeun[payload.j].list;
      }
      // mid
      let mid = null;
      if (payload.h >= 0) mid = payload.h;
      if (payload.i >= 0) mid = mid + '_' + payload.i;
      if (payload.j >= 0) mid = mid + '_' + payload.j;
      if (payload.k >= 0) mid = mid + '_' + payload.k;
      commit("SET_MID", mid)
      commit("SET_MENU_LIST", {
        firstMenu: menu.menuList,
        secondMenu: secondMenu,
        thirdMeun: thirdMeun,
        fourthMeun: fourthMeun,
      });
      commit("SET_MENU_IDS", {
        f_id: payload.h,
        s_id: payload.i,
        t_id: payload.j,
        four_id: payload.k
      });
    },
    getMob(store) {
      let isMob = /Android|webOS|iPhone|iPod|iPad|BlackBerry/i.test(navigator.userAgent);
      if (isMob) {
        store.commit("SET_MOB", isMob);
      }
    },
    getVirtualLink({
      commit
    }, payload) {
      commit("SET_VIRTUAL_LINK", payload[store.state.lang]);
    },
  },
  getters: {
    virtualLink: state => state.virtualLink,
  }
})